import { render, staticRenderFns } from "./HoldDialog.vue?vue&type=template&id=c5ac7d9c&scoped=true"
import script from "./HoldDialog.vue?vue&type=script&lang=js"
export * from "./HoldDialog.vue?vue&type=script&lang=js"
import style0 from "./HoldDialog.vue?vue&type=style&index=0&id=c5ac7d9c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ac7d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ac7d9c')) {
      api.createRecord('c5ac7d9c', component.options)
    } else {
      api.reload('c5ac7d9c', component.options)
    }
    module.hot.accept("./HoldDialog.vue?vue&type=template&id=c5ac7d9c&scoped=true", function () {
      api.rerender('c5ac7d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/HoldDialog.vue"
export default component.exports